module.exports = __webpack_public_path__ + "static/img/apple@3x.e46d01f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/apple@3x.png
// module id = ri9f
// module chunks = 0